export default "__VITE_ASSET__BL$UhQ$A__"